export default {"src":"/_next/static/media/home-smiley-icon.d8ec39ac.svg","height":38,"width":39,"blurWidth":0,"blurHeight":0};